import { Card } from '@growdash/design-system/atoms';
import MenuItemCard from '@growdash/growintel/components/molecules/menu-list-card';
import { UniqueMenuItem } from '@growdash/growintel/generated';
import groupByField from '@growdash/growintel/utils/group-by-field';
import { Loader2 } from 'lucide-react';
import { useMemo, useState } from 'react';
import CategorySelector from './category-selector';

type Props = {
  items: UniqueMenuItem[];
  isLoading: boolean;
  isCompetitorComponent?: boolean;
};

export default function MenuItems({
  items,
  isLoading,
  isCompetitorComponent,
}: Props) {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);

  const groupedItems = useMemo(
    () => groupByField<UniqueMenuItem>(items, 'item_category'),
    [items],
  );

  const categoryFilteredItems = useMemo(() => {
    if (!selectedCategories.length) return items;
    return items?.filter((i) =>
      selectedCategories.includes(i.item_category ?? ''),
    );
  }, [items, selectedCategories]);
  return (
    <>
      {isLoading ? (
        <Card className="p-4 flex items-center justify-center h-64 animate-fade-in">
          <div className="animate-pulse">
            <Loader2 className="animate-spin" />
          </div>
        </Card>
      ) : (
        <></>
      )}

      {!isLoading && (
        <div
          className={`${
            isCompetitorComponent
              ? 'bg-gradient-orange-border shadow-[0px_4px_8px_0px_#B4B0B03B] p-[1px] '
              : 'border !p-0'
          }  min-h-16 flex flex-col gap-2 animate-fade-in rounded-xl overflow-hidden items-center`}
        >
          <div className="w-full relative bg-background rounded-[11px]">
            <div className="min-w-full">
              <CategorySelector
                isCompetitorComponent={isCompetitorComponent}
                categories={Object.keys(groupedItems)}
                onValueChange={setSelectedCategories}
              />
              {!!items?.length ? (
                <div className="grid grid-cols-2 max-md:grid-cols-1 gap-1 p-2 md:p-4 h-[400px] overflow-y-scroll scrollbar-hidden">
                  {categoryFilteredItems.map((item) => (
                    <MenuItemCard key={item.item_name} {...item} />
                  ))}
                </div>
              ) : (
                <div className="flex items-center justify-center p-8 text-muted-foreground">
                  No items found
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
